import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { DocumentDatabase, EventDatabse } from "../../../types";
import { _3_DAYS } from "../../../constants/durations";

export type EventById = EventDatabse & {
  documents: DocumentDatabase[];
}

async function fetchEventById(id: string): Promise<EventById> {
  const { data, error } = await apiClient
    .from('events')
    .select(`*, documents (*, document_types:document_type_id(id, name))`)
    .eq('id', id)
    .single();

  if (error) {
    throw error;
  }

  const rawEvent = data as unknown as EventDatabse & {
    documents: (DocumentDatabase & { document_types: { id: string; name: string } | null })[];
  };

  const documents: DocumentDatabase[] = (rawEvent.documents ?? []).map((doc) => ({
    ...doc,
    type: doc.document_types?.name ?? null,
  }));

  return {
    ...rawEvent,
    documents,
  };
}

export function useGetEventById(id: string | undefined) {

  return useQuery({
    queryKey: keys.detail(id ?? ''),
    queryFn: () => fetchEventById(id!),
    enabled: !!id,
    staleTime: _3_DAYS
  })
}
